import { Formatters, Messages } from '../../../codegen/Localize';
import {
  ActionHelpers,   standardActionErrorMsg,
standardActionSuccessMsg
} from '../../../commonInfra/contentActions/ActionHelpers';
import { IErrorItem } from '../../../commonInfra/contentActions/MultipleItemResult';
import { openReactConfirmationDialog } from '../../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../../commonInfra/dialogs/style/TabDialogWidth';
import { AccelerationTasks } from '../../../dataAcceleration/resources/AccelerationTasks';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { L10n } from '../../L10n/L10n';
import { IAccelerationTaskInfo } from '../../models/IAccelerationTaskInfo';
import { Set } from '../../models/Set';
import { DataAccelerationErrors } from './DataAccelerationErrors';

function showRunDataAccelerationDialog(
  accelerationTasks: Set<IAccelerationTaskInfo>): Promise<any> {

  let dialogBody: string;
  const taskCount = accelerationTasks.size();
  if (taskCount === 1) {
    const task = accelerationTasks.first();
    dialogBody = Messages.runDataAccelerationTasksForWorkbookRunPrompt({
      WORKBOOK_NAME: L10n.elideIfLong(task.workbook.name)
    });
  } else {
    dialogBody = Messages.runDataAccelerationTasksRunPrompt({
      ITEM_COUNT_LOC: Formatters.formatCount(taskCount)
    });
  }

  const dialogInstance = openReactConfirmationDialog<string[], IResult>({
    title: Messages.runNow(),
    message: dialogBody,
    actionName: Messages.runNowConfirmButton(),
    paramsForAction: accelerationTasks.keys(),
    action: AccelerationTasks.run.bind(AccelerationTasks),
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IResult) => {
    ActionHelpers.displayStandardToastsForResult(
      accelerationTasks,
      result,
      {
        success: standardActionSuccessMsg(Messages.runDataAccelerationTasksRunSuccess),
        error: standardActionErrorMsg(Messages.runDataAccelerationTasksRunError),
      },
      (errorItem: IErrorItem<IAccelerationTaskInfo>) => DataAccelerationErrors.errorDetailsForTasks(errorItem)
    );
  });

  return dialogInstance.result;
}

export const RunDataAccelerationTasksAction = {
  showRunDataAccelerationDialog
};

export type RunDataAccelerationTasksAction = typeof RunDataAccelerationTasksAction;
